import { config } from '../../config/config';
import {
    CreateReferralParams,
    ReferralDataType,
    ReferralReturnType,
} from '../../context/referral/refferalTypes';
import post from './post';

export const getReferralFromLocalStorage = () => {
    const referrral = JSON.parse(localStorage.getItem('referral') || '{}');

    return Object.keys(referrral).length ? (referrral as ReferralDataType) : undefined;
};

export const getReferralLink = (imageId: string, refCode: string) => {
    return new URL(
        `${window.location.origin}/share/${imageId}?refCode=${refCode}`
    ).toString();
};

export const getReferralByCreator = async (creator: string) => {
    const res = await fetch(
        `${config.urls.unlimitedReferralApi}/referrals/code/${creator.toLowerCase()}`,
        {
            headers: {
                accepts: 'application/json',
            },
        }
    );

    const referral: ReferralReturnType = await res.json();

    return referral;
};

export const getReferralById = async (referralId: string) => {
    const res = await fetch(
        `${config.urls.unlimitedReferralApi}/referrals/address/${referralId}`,
        {
            headers: {
                accepts: 'application/json',
            },
        }
    );

    const referral: ReferralReturnType = await res.json();

    return referral;
};

export const createReferral = async ({
    code,
    signature,
    address,
}: CreateReferralParams) => {
    const res = await post(`${config.urls.unlimitedReferralApi}/referrals/code/create`, {
        code,
        signature,
        address,
    });

    if (res.errors) {
        throw new Error(JSON.stringify(res.errors));
    }
};
